import { cloneDeep } from 'lodash';
import { useState } from 'react';

const progressList = [
  {
    title: '创建超级管理员账号',
    key: 'CREATE_USER',
    progree: 8,
  },
  {
    title: '创建景区',
    key: 'CREATE_SCENIC',
    progree: 16,
  },
  {
    title: '创建企业',
    key: 'CREATE_COMPANY',
    progree: 24,
  },
  {
    title: '开通慧景云权限',
    key: 'SCENIC_PERMISSION',
    progree: 62,
  },
  {
    title: '开通易旅通权限',
    key: 'COMPANY_PERMISSION',
    progree: 90,
  },
  {
    title: '完成，正在跳转',
    key: 'COMPLETE',
    progree: 100,
  },
];

export default function useRegisterProgress(
  isCreateScenic: boolean,
  formData: React.MutableRefObject<any[]>,
) {
  const [progressState, setProgressState] = useState<any>({
    title: '开始注册',
  });

  const [progressText, setProgressText] = useState<{ text: string; style: any }[]>(
    new Array(2).fill(null).map((_) => {
      return {
        text: '',
        style: { opacity: 0, transition: '0.5s', position: 'absolute', transitionDelay: '0s' },
      };
    }),
  );

  /**
   * 设置下一条要显示的提示
   */
  const progressTextChange = (progress: any) => {
    let newData = cloneDeep(progressText);
    const showFirst = newData[0].style.opacity == 0;
    const showIndex = showFirst ? 0 : 1;
    const hideIndex = showFirst ? 1 : 0;

    newData[showIndex].text = progress.title;
    newData[showIndex].style.opacity = 1;
    newData[showIndex].style['transitionDelay'] = '0.5s';
    newData[hideIndex].style.opacity = 0;
    newData[hideIndex].style['transitionDelay'] = '0s';

    setProgressText(newData);
  };

  /**
   * 模拟进度条
   */
  const simulateProgress = (key: string) => {
    const progress = progressList.find((item) => item.key === key) || { progree: 0 };
    setProgressState(progress);
    progressTextChange(progress);

    if (key === 'COMPLETE') {
      let scenicInfo = formData.current[0];
      const SCENIC_HOST = import.meta.env.VITE_SCENIC_HOST;
      let redirection = import.meta.env.VITE_URL_EXCHANGE;
      if (isCreateScenic) {
        redirection = SCENIC_HOST + '/#/' + scenicInfo?.uniqueIdentity ?? 'none' + '/';
      }
      setTimeout(() => {
        window.location.href = redirection;
      }, 500);
    }
  };

  const sseProgress = () => {
    const sseCode = Date.now();
    const eventSource = new EventSource(`${import.meta.env.VITE_API_BASE}/sse/get/${sseCode}`);
    eventSource.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log(data);
        simulateProgress(data);
      } catch (error) {
        console.error(error);
      }
    };

    eventSource.onopen = () => {
      console.log('Connection to server opened.');
    };

    eventSource.onerror = (event) => {
      if (event?.readyState === EventSource.CLOSED) {
        console.log('Connection to server closed.');
      } else {
        console.error('Error occurred:', event);
      }
    };

    return sseCode;
  };

  return {
    progressState,
    setProgressState,
    sseProgress,
    simulateProgress,
  };
}
